import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

function init() {
    document.addEventListener('DOMContentLoaded', function () {
        const $swipers = $('.c-swiper');
        if (!$swipers.length) return;
        
        // Define helper functions first
        function setContentHeight($content) {
            // Only proceed if we have content elements
            if (!$content.length) return;
            
            // Clear any existing heights first
            $content.css('height', '');
            
            // Force a reflow to get accurate measurements
            $content[0].offsetHeight;
            
            // Calculate the maximum height
            const heights = $content.map(function () {
                const $this = $(this);
                // Ensure the element is visible for accurate measurement
                if ($this.is(':visible')) {
                    return Math.round($this.height());
                }
                return 0;
            }).get();
            
            const maxHeight = Math.max.apply(null, heights);
            
            // Only set height if we have a valid maxHeight
            if (maxHeight > 0) {
                $content.height(maxHeight);
            }
        }

        function updateSwiperContent($swiper) {
            // Only proceed if swiper element exists and is visible
            if (!$swiper.length || $swiper.is(':hidden')) return;
            
            const isBookBlock = $swiper.hasClass('c-book-block');
            if (isBookBlock) {
                const $contentElements = $swiper.find('.c-book-block__content');
                if ($contentElements.length > 0) {
                    setContentHeight($contentElements);
                }
            }

            const isBookBlockAlt = $swiper.hasClass('c-book-block-alt');
            if (isBookBlockAlt) {
                const chunks = [[], [], []];

                const slides = $swiper.find('.c-swiper__slide').toArray();
                slides.forEach((slide) => {
                    const $bookBlockAltSlides = $(slide).children();
                    $bookBlockAltSlides.each((index, el) => {
                        chunks[index].push(el);
                    });
                });

                chunks.forEach((chunk) => {
                    if (chunk.length > 0) {
                        setContentHeight($(chunk));
                    }
                });
            }
        }

        // Calculate and set content heights IMMEDIATELY to prevent any jumping
        $swipers.each((index, el) => {
            const $swiper = $(el);
            updateSwiperContent($swiper);
        });

        // Define breakpoints and debounce delay
        const breakpoints = {
            phone: 320,
            phoneLarge: 600,
            tablet: 768,
            tabletLandscape: 1024,
            desktop: 1132,
        };

        let currentBreakpoint = getBreakpoint();

        // Debounce utility function
        function debounce(func, delay) {
            let timeout;
            return function (...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), delay);
            };
        }

        // Get current breakpoint based on screen width
        function getBreakpoint() {
            const width = window.innerWidth;
            if (width < breakpoints.phoneLarge) return 'phone';
            if (width < breakpoints.tablet) return 'phoneLarge';
            if (width < breakpoints.desktop) return 'tablet';
            if (width < breakpoints.tabletLandscape) return 'tabletLandscape';
            return 'desktop';
        }

        // Handle breakpoint change with debounce
        const onResize = debounce(() => {
            const newBreakpoint = getBreakpoint();
            if (newBreakpoint !== currentBreakpoint) {
                currentBreakpoint = newBreakpoint;
                chunkForSetContent();
            }
        }, 250);

        // Listen to resize events
        window.addEventListener('resize', onResize);

        // PubSub and Swiper initialization
        PubSub.subscribe('app:ready', function () {
            $swipers.each((index, el) => {
                initSwiper(el);
            });
        });

        // Fallback initialization after 1 second
        setTimeout(() => {
            $swipers.each((index, el) => {
                if (!el.swiper) {
                    initSwiper(el);
                }
            });
        }, 1000);

        PubSub.subscribe('fontface:loaded', chunkForSetContent);
        PubSub.subscribe('load-more:success', chunkForSetContent);

        function chunkForSetContent() {

            $swipers.each((index, el) => {
                const $swiper = $(el);
                updateSwiperContent($swiper);
            });
        }

        function updateNavigationState(swiper, $el) {
            const swiperLayout = $el.attr('data-swiper-layout');
            const hasMoreSlides = hasMoreSlidesAt(currentBreakpoint, $el);
            const noOfSlides = $el.find('.c-swiper__slide').length;
            
            // For banner sliders, show navigation if there are multiple slides
            const shouldShowNavigation = swiperLayout === 'banner' ? noOfSlides > 1 : hasMoreSlides;
            
            // Update touch movement (banners have their own touch settings)
            if (swiperLayout !== 'banner') {
                swiper.allowTouchMove = hasMoreSlides;
            }
            
            // Update navigation visibility and state
            const $navContainer = $el.find('.c-title-bar__nav, .c-banner-home__nav');
            if ($navContainer.length) {
                $navContainer.toggleClass('active', shouldShowNavigation);
            }

            // For banner sliders with infinite loop, navigation should never be disabled
            let canSlidePrev, canSlideNext;
            
            if (swiperLayout === 'banner' && swiper.loopedSlides) {
                // Banner with infinite loop - navigation is always enabled
                canSlidePrev = true;
                canSlideNext = true;
            } else {
                // Regular swipers - use Swiper's built-in properties
                canSlidePrev = swiper.allowSlidePrev && !swiper.isBeginning;
                canSlideNext = swiper.allowSlideNext && !swiper.isEnd;
            }

            // Update individual navigation buttons using Swiper's built-in navigation state
            if (swiper.navigation && swiper.navigation.nextEl) {
                const $nextBtn = $(swiper.navigation.nextEl);
                // For banner sliders with infinite loop, never disable buttons
                if (swiperLayout === 'banner' && swiper.loopedSlides) {
                    $nextBtn.prop('disabled', false);
                    $nextBtn.removeClass('swiper-button-disabled');
                } else {
                    $nextBtn.prop('disabled', !canSlideNext);
                    $nextBtn.toggleClass('swiper-button-disabled', !canSlideNext);
                }
            }
            
            if (swiper.navigation && swiper.navigation.prevEl) {
                const $prevBtn = $(swiper.navigation.prevEl);
                // For banner sliders with infinite loop, never disable buttons
                if (swiperLayout === 'banner' && swiper.loopedSlides) {
                    $prevBtn.prop('disabled', false);
                    $prevBtn.removeClass('swiper-button-disabled');
                } else {
                    $prevBtn.prop('disabled', !canSlidePrev);
                    $prevBtn.toggleClass('swiper-button-disabled', !canSlidePrev);
                }
            }

            // Also update navigation buttons directly if Swiper's navigation isn't working
            const $prevBtnDirect = $el.find('.js-swiper-prev');
            const $nextBtnDirect = $el.find('.js-swiper-next');
            
            if ($prevBtnDirect.length) {
                // For banner sliders with infinite loop, never disable buttons
                if (swiperLayout === 'banner' && swiper.loopedSlides) {
                    $prevBtnDirect.prop('disabled', false);
                    $prevBtnDirect.removeClass('swiper-button-disabled');
                } else {
                    $prevBtnDirect.prop('disabled', !canSlidePrev);
                    $prevBtnDirect.toggleClass('swiper-button-disabled', !canSlidePrev);
                }
            }
            
            if ($nextBtnDirect.length) {
                // For banner sliders with infinite loop, never disable buttons
                if (swiperLayout === 'banner' && swiper.loopedSlides) {
                    $nextBtnDirect.prop('disabled', false);
                    $nextBtnDirect.removeClass('swiper-button-disabled');
                } else {
                    $nextBtnDirect.prop('disabled', !canSlideNext);
                    $nextBtnDirect.toggleClass('swiper-button-disabled', !canSlideNext);
                }
            }

            // Update pagination if it exists
            if (swiper.pagination && swiper.pagination.el) {
                const $pagination = $(swiper.pagination.el);
                $pagination.toggleClass('swiper-pagination-hidden', !shouldShowNavigation);
            }
            

        }

        function initSwiper(el) {
            const $el = $(el);
            
            // Check if swiper already exists
            if ($el[0].swiper) {
                $el[0].swiper.destroy(true, true);
            }

            // Heights are already calculated during DOM ready phase

            const hasMoreSlides = hasMoreSlidesAt(currentBreakpoint, $el);
            $el.toggleClass('has-more-slides', hasMoreSlides);
            
            // Add loading state to prevent premature navigation
            $el.addClass('swiper-loading');

            // Find navigation and pagination elements
            // IMPORTANT: Navigation buttons are in the title bar, outside the swiper container
            const $navContainer = $el.find('.c-title-bar__nav, .c-banner-home__nav');
            const $pagination = $el.find('.swiper-pagination, .c-banner-home__pagination');
            
            // Find navigation buttons within the entire swiper element (including title bar)
            // For banner-home, the buttons are inside the .c-banner-home element but outside .c-swiper__container
            const $prevBtn = $el.find('.js-swiper-prev');
            const $nextBtn = $el.find('.js-swiper-next');
            
            // Ensure we have the actual DOM elements for navigation
            const prevEl = $prevBtn.length > 0 ? $prevBtn[0] : null;
            const nextEl = $nextBtn.length > 0 ? $nextBtn[0] : null;
            
            // Verify navigation elements are found
            if (!prevEl || !nextEl) {
                // Navigation elements not found - this is expected for some swiper layouts
            }
            

            
            // Base swiper configuration
            const swiperConfig = {
                modules: [Navigation, Pagination],
                wrapperClass: 'c-swiper__wrap',
                slideClass: 'c-swiper__slide',
                slideActiveClass: 'is-active',
                slideDuplicateActiveClass: 'is-duplicate-active',
                slideVisibleClass: 'is-visible',
                slideDuplicateClass: 'is-duplicate',
                slideNextClass: 'is-next',
                slideDuplicateNextClass: 'is-duplicate-next',
                slidePrevClass: 'is-prev',
                slideDuplicatePrevClass: 'is-duplicate-prev',
                containerModifierClass: 'c-swiper__container--',
                
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                spaceBetween: 0,
                watchSlidesProgress: true,
                allowTouchMove: hasMoreSlides,
                centeredSlides: false,
                freeMode: false,
                
                // Navigation configuration - use the actual DOM elements
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl,
                    disabledClass: 'swiper-button-disabled',
                    hiddenClass: 'swiper-button-hidden',
                },
                
                // Pagination configuration
                pagination: $pagination.length ? {
                    el: $pagination[0],
                    clickable: true,
                    bulletClass: 'swiper-pagination-bullet',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    renderBullet: function (index, className) {
                        return `<span class="${className}"></span>`;
                    },
                } : false,
                
                // Events
                on: {
                    init: function () {
                        // Remove loading state once swiper is fully initialized
                        $el.removeClass('swiper-loading');
                        updateNavigationState(this, $el);
                        PubSub.publish('text-clamp:run');
                        
                        // Handle image loading
                        const $images = $el.find('.c-book-block__thumb img, .c-book-block-alt__thumb img');
                        if ($images.length > 0) {
                            $images.on('load', () => updateSwiperContent($el));
                        }
                    },
                    
                    slideChange: function () {
                        updateNavigationState(this, $el);
                        // Recalculate content heights after slide change
                        updateSwiperContent($el);
                    },
                    
                    slideChangeTransitionStart: function () {
                        updateNavigationState(this, $el);
                    },
                    
                    slideChangeTransitionEnd: function () {
                        updateNavigationState(this, $el);
                        // Ensure heights are consistent after transition
                        updateSwiperContent($el);
                        
                        // Debounced height recalculation in case content changes after transition
                        setTimeout(() => {
                            updateSwiperContent($el);
                        }, 100);
                    },
                    
                    reachBeginning: function () {
                        updateNavigationState(this, $el);
                    },
                    
                    reachEnd: function () {
                        updateNavigationState(this, $el);
                    },
                    
                    fromEdge: function () {
                        updateNavigationState(this, $el);
                    },
                    
                    toEdge: function () {
                        updateNavigationState(this, $el);
                    },
                    
                    resize: debounce(function () {
                        // Don't force slide to 0 on resize - let swiper maintain current position
                        updateNavigationState(this, $el);
                    }, 250),
                    
                    update: function () {
                        updateNavigationState(this, $el);
                    },
                },
                
                init: false,
            };

            // Special configurations for different swiper types
            const swiperLayout = $el.attr('data-swiper-layout');
            
            if (swiperLayout === 'banner') {
                const noOfSlides = $el.find('.c-swiper__slide').length;
                
                // Initialize background image manager for banner
                const initBannerBackgrounds = () => {
                    // Find backgrounds in the wrapper container
                    const $backgrounds = $el.closest('.c-banner-home__wrapper').find('.c-banner-home__background');
                    
                    let currentBgIndex = 0;
                    let isTransitioning = false;
                    let transitionQueue = [];
                    
                    // Ensure first background is active (images are now actual img tags)
                    const $firstBg = $backgrounds.eq(0);
                    $firstBg.addClass('is-active');
                    
                    // No need to preload images - they're already in the HTML as img tags
                    
                    // Background transition function
                    const transitionToBackground = (targetIndex) => {
                        if (isTransitioning || targetIndex === currentBgIndex) return;
                        
                        isTransitioning = true;
                        
                        // Remove active class from all backgrounds first
                        $backgrounds.removeClass('is-active');
                        
                        // Add active class to target background
                        const $targetBg = $backgrounds.eq(targetIndex);
                        $targetBg.addClass('is-active');
                        
                        currentBgIndex = targetIndex;
                        
                        setTimeout(() => {
                            isTransitioning = false;
                            if (transitionQueue.length > 0) {
                                const nextIndex = transitionQueue.shift();
                                transitionToBackground(nextIndex);
                            }
                        }, 800);
                    };
                    
                    // Queue management
                    const queueBackgroundTransition = (targetIndex) => {
                        if (targetIndex === currentBgIndex) {
                            return;
                        }
                        
                        if (!isTransitioning) {
                            transitionQueue = [targetIndex]; // Clear queue and set new target
                            transitionToBackground(targetIndex);
                        } else {
                            transitionQueue = [targetIndex]; // Replace queue with new target
                        }
                    };
                    
                    return { queueBackgroundTransition };
                };
                
                const backgroundManager = initBannerBackgrounds();
                
                // Banner swiper with fade effect
                Object.assign(swiperConfig, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    allowTouchMove: true, // Enable draggable functionality
                    speed: 1000,
                    loop: true, // Enable looping
                    loopedSlides: noOfSlides, // Ensure proper loop behavior
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    // Force navigation and pagination for banner (always show if multiple slides)
                    navigation: nextEl && prevEl ? {
                        nextEl: nextEl,
                        prevEl: prevEl,
                        disabledClass: 'swiper-button-disabled',
                        hiddenClass: 'swiper-button-hidden',
                    } : false,
                    pagination: $pagination.length ? {
                        el: $pagination[0],
                        clickable: true,
                        bulletClass: 'c-banner-home__bullet',
                        bulletActiveClass: 'is-active',
                        renderBullet: function (index, className) {
                            return `<span class="${className}"></span>`;
                        },
                    } : false,
                    on: {
                        slideChange: function() {
                            // Use realIndex for looped swipers to get the actual slide index
                            const slideIndex = this.realIndex !== undefined ? this.realIndex : this.activeIndex;
                            backgroundManager.queueBackgroundTransition(slideIndex);
                        },
                        slideChangeTransitionStart: function() {
                            // Also handle background transition on transition start for smoother experience
                            const slideIndex = this.realIndex !== undefined ? this.realIndex : this.activeIndex;
                            backgroundManager.queueBackgroundTransition(slideIndex);
                        }
                    }
                });
                
            } else if (swiperLayout === 'gallery') {
                // Gallery swiper
                Object.assign(swiperConfig, {
                    spaceBetween: 12,
                    slidesPerView: 'auto',
                    centeredSlides: false,
                });
            }

            // Initialize swiper
            const swiperContainer = $el.find('.c-swiper__container')[0];
            const swiper = new Swiper(swiperContainer, swiperConfig);
            
            // Store swiper instance on the element
            $el[0].swiper = swiper;
            
            // Initialize
            swiper.init();
            
            // Ensure navigation state is updated after initialization
            setTimeout(() => {
                updateNavigationState(swiper, $el);
                
                // Debug: Test navigation functionality
                // console.log({
                //     swiper: swiper,
                //     navigation: swiper.navigation,
                //     allowSlidePrev: swiper.allowSlidePrev,
                //     allowSlideNext: swiper.allowSlideNext,
                //     isBeginning: swiper.isBeginning,
                //     isEnd: swiper.isEnd,
                //     activeIndex: swiper.activeIndex,
                //     slidesLength: swiper.slides.length
                // });
            }, 100);
        }



        function hasMoreSlidesAt(bp, $el) {
            const swiperLayout = $el.attr('data-swiper-layout');
            const noOfSlides = $el.find('.c-swiper__slide').length;


            const config = {
                book: { phone: 2, phoneLarge: 4, tablet: 4, tabletLandscape: 6, desktop: 6 },
                category: { phone: 1, phoneLarge: 1, tablet: 2, tabletLandscape: 3, desktop: 3 },
                categoryAlt: { phone: 2, phoneLarge: 2, tablet: 4, tabletLandscape: 6, desktop: 6 },
                bookAlt: { phone: 1, phoneLarge: 1, tablet: 2, tabletLandscape: 3, desktop: 3 },
                events: { phone: 1, phoneLarge: 1, tablet: 2, tabletLandscape: 3, desktop: 3 },
                banner: { phone: 1, phoneLarge: 1, tablet: 1, tabletLandscape: 1, desktop: 1 }, // Banner always shows 1 slide
                'book-hero': {}, // Populated dynamically
            };

            // Dynamic config for 'book-hero'
            if (swiperLayout === 'book-hero') {
                const isSingle = $el.hasClass('is-single');
                const isDouble = $el.hasClass('is-double');
                const isTriple = $el.hasClass('is-triple');
                let numPerSlide = 1;

                switch (bp) {
                    case 'phone':
                        config['book-hero'].phone = 1;
                        break;
                    case 'phoneLarge':
                        numPerSlide = isSingle ? 1 : isDouble ? 2 : 2;
                        config['book-hero'].phoneLarge = numPerSlide;
                        break;
                    case 'tablet':
                        numPerSlide = isSingle ? 1 : isDouble ? 2 : 2;
                        config['book-hero'].tablet = numPerSlide;
                        break;
                    case 'tabletLandscape':
                    case 'desktop':
                        numPerSlide = isSingle ? 1 : isDouble ? 2 : 3;
                        config['book-hero'].tabletLandscape = numPerSlide;
                        config['book-hero'].desktop = numPerSlide;
                        break;
                }
            }

            const threshold = config[swiperLayout]?.[bp];
            return noOfSlides > threshold;
        }
    });
}

export default init;
